export default __webpack_public_path__ + "static/media/SearchBlueIcon.404804ba.png";